import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import ProjectApiService from '@lib/api-services/ProjectApiService';
import buildResourcePath from '@lib/buildResourcePath';
import UIServicesRegistry from '@lib/ui-services/UIServicesRegistry';
import XMessageUIService from '@lib/ui-services/XMessageUIService';
import {observer} from 'mobx-react';
import React, {Component} from 'react';
import ProjectStore from '../../store/projectStore';
import Button from '../common/Button';
import Dropdown from '../common/DropdownReact';
import FilesCard from '../file/FilesCard';
import IconSave from '../icons/IconSave';
import IconExportPDF from '../icons/IconExportPDF';
import IconExportXLS from '../icons/IconExportXLS';
import IconExportXML from '../icons/IconExportXML';
import ComunicationCard from './CommunicationCard';
import HistoryCard from './HistoryCard';
import ProjectCollaborationCard from './ProjectCollaborationCard';
import ProjectConfigurations from './ProjectConfigurations';
import ProjectCustomer from './ProjectCustomer';
import ProjectDeleteModal from './ProjectDeleteModal';
import ProjectDocumentationModal from './ProjectDocumentationModal';
import ProjectXlsSpecificationModal from './ProjectXlsSpecificationModal'
import ProjectXmlSpecificationModal from './ProjectXmlSpecificationModal'
import ProjectExpandableFloatingDropdown from './ProjectExpandableFloatingDropdown';
import ProjectGeneralInformation from './ProjectGeneralInformation';
import ProjectSendQuoteModal from './ProjectSendQuoteModal';
import ProjectStatusHelper from './ProjectStatusHelper';
import ProjectHelper from './ProjectHelper';
import TransformToProductionOrderInformationModal from './modals/TransformToProductionOrderInformationModal';
import ResultOfTransformToProductionOrderModal from './modals/ResultOfTransformToProductionOrderModal';
import DeliveryDocumentationModal from './modals/DeliveryDocumentationModal';
import CopyQuoteOrderProductionOrderInformationModal from './modals/CopyQuoteOrderProductionOrderIInformationModal';
import CreateReviseInformationModal from './modals/CreateReviseInformationModal';
import Loader from '../common/Loader';
import MessageAPIService from '@lib/api-services/MessageAPIService';
import { MessagesAPIService } from '@lib/api-services/MessagesAPIService';
import {Message} from "../../../src/application/Contracts";

const ProjectEditPage = observer(
    class ProjectEditPage extends Component {

        transformToProductionOrderValue = 8;

        state = {
            substationDocumentationModalIsOpen: false,
            deliveryDocumentationModalIsOpen: false,
            xlsSpecificationModalIsOpen: false,
            xmlSpecificationModalIsOpen: false,
            isTransforming: false,
            sendQuoteModalVisible: false,
            transformToProductionOrderInformationModalVisible: false,
            resultOftransformToProductionOrder: [],
            resultOfTransformToProductionOrderModalVisible: false,
            copyQuoteOrderProductionOrderInformationModalVisible: false,
            createReviseModalVisible: false
        }

        constructor(props) {
            super(props)
            ProjectStore.initModel({
                id: props.model.id,
                isEditable: props.model.isEditable,
                generalInformation: props.model.generalInformation,
                files: props.model.files,
                configurations: props.model.configurations,
                viewers: props.model.viewers,
                participants: props.model.participants,
                summary: props.model.summary,
                _forceUpdate: false
            })

            this.loadDropdownItems();

            scheduleAtDocumentReady(() => {
                this.projectApiService = APIServicesRegistry.getService(ProjectApiService)
                this.xMessageUIService = UIServicesRegistry.getService(XMessageUIService)
                this.setState({_forceUpdate: !this.state._forceUpdate});
            })


            window.onbeforeunload = e => {
                e = e || window.event;

                if (ProjectStore.dirty) {
                    const message = __('Changes that you have made will not be saved.');

                    if (e) {
                        e.returnValue = message;
                    }

                    return message;
                }
            }
        }

        onCreateNewConfigurationClick = () => {
            if (ProjectStore.isNew()) {
                this.xMessageUIService.pushNotification({
                    type: 'info',
                    title: __('Info'),
                    text: __('Before adding new configuration you must save project.'),
                    timeout: 5
                });
            } else {
                window.location.href = buildResourcePath(`Project/CreateConfiguration?projectId=${ProjectStore.formModel.id.value}`);
            }
        }

        onAddExistingConfigurationClick = () => {
            ProjectStore.setAddExistingConfigurationModalVisible(true);
        }

        loadDropdownItems() {
            let dropdownItems = [];
            dropdownItems.push({id: 0, label: __('Substation documentation'), icon: IconExportPDF});
            dropdownItems.push({id: 1, label: __('Delivery documentation'), icon: IconExportPDF});

            if (this.props.hasSpecificationForOrderProcessingXlsPermission)
                dropdownItems.push({id: 2, label: __('Spec for order processing (XLS)'), icon: IconExportXLS});

            const isOrder = this.props.model.generalInformation.status.value === 'Order' || this.props.model.generalInformation.status.value === 'ProductionOrder';
            if (isOrder)
                dropdownItems.push({id: 3, label: __('Sign label data (XML)'), icon: IconExportXML});

            this.dropdownOptions = dropdownItems;
        }

        onDocsGenerateDropdownItemClick = item => {
            if (item.id === 0)
                this.setState({substationDocumentationModalIsOpen: true});
            if (item.id === 1)
                this.setState({deliveryDocumentationModalIsOpen: true});
            if (item.id === 2)
                this.setState({xlsSpecificationModalIsOpen: true});
            if (item.id === 3)
                this.setState({xmlSpecificationModalIsOpen: true});
        }

        onSaveClick = () => {
            if (!ProjectStore.canSave())
                return;

            ProjectStore.setDuringSave(true);

            let model = ProjectStore.getTransformedFormModel();
            ProjectStore.setDirty(false);
            if (ProjectStore.isNew())
                this.projectApiService.create(model).then(() => {

                    ProjectStore.setDuringSave(false);
                })
            else
                this.projectApiService.edit(model).then((response) => {
                    ProjectStore.setDuringSave(false);
                    ProjectStore.updateConfigurationIds(response.data.configurations)
                });
        }

        onDeleteClick = () => {
            if (!ProjectStore.isNew())
                ProjectStore.setDeleteModalVisible(true)
        }

        onCopyClick = () => {
            if (ProjectHelper.isQuoteOrOrderOrProduction(ProjectStore.formModel.generalInformation.status.value)) {
                this.setState({
                    copyQuoteOrderProductionOrderInformationModalVisible: true
                })
            } else {
                this.copy();
            }
        }

        onReviseClick = () => {
            if (ProjectHelper.isQuoteOrOrderOrProduction(ProjectStore.formModel.generalInformation.status.value)) {
                this.setState({
                    createReviseModalVisible: true
                })
            } else {
                this.revise();
            }
        }

        onDeletePostClick = () => {
            ProjectStore.duringDelete = true
            this.projectApiService.delete(ProjectStore.formModel.id.value).then(res => {
                window.location.href = buildResourcePath('Projects')
            })
        }

        getTitle = () => {
            if (ProjectStore.isNew())
                return (
                    <div className="project-edit-title">
                        {__('New Project')}
                    </div>
                );

            return (
                <div className="project-edit-title">
                    {this.props.model.title}
                    {ProjectStatusHelper.getTag(this.props.model.generalInformation.status.value)}
                </div>
            )
        }

        getTransformOption() {
            let items = this.props.model.transformOptions.items || [];
            let options = items.map(o => {
                return {id: o.value, label: o.text}
            });
            return options;
        }

        onTransformClick(item) {
            if (this.state.isTransforming) {
                return;
            }

            if (ProjectStore.dirty) {
                this.xMessageUIService.pushNotification({
                    type: 'info',
                    title: __('Info'),
                    text: __('Save and then transform.'),
                    timeout: 5
                });

                return;
            }

            if (item.id === this.transformToProductionOrderValue) {

                var transformToProductionOrderOption = this.props.model.transformOptions.items.find(x => x.value === this.transformToProductionOrderValue);
                if (transformToProductionOrderOption) {
                    var split = (transformToProductionOrderOption.attributes || {})['splitBetweenProductionSite'];
                    if (split) {
                        this.setState({
                            transformToProductionOrderInformationModalVisible: true
                        })
                    } else {
                        this.transform(item);
                    }
                } else {
                    this.transform(item);
                }
            } else {
                this.transform(item);
            }
        }

        transform(item) {
            this.setState({isTransforming: true})

            let data = {
                projectId: ProjectStore.formModel.id.value,
                transformation: item.id
            };

            this.projectApiService.transform(data)
                .catch(() => {
                    this.setState({isTransforming: false})
                })
        }

        onProjectFilesChange = files => {
            ProjectStore.formModel.files = files;
            ProjectStore.setDirty(true);
        }

        onCollaborationParticipantsChanged = participants => ProjectStore.formModel.participants = participants;

        onCollaborationViewersChanged = viewers => ProjectStore.formModel.viewers = viewers;

        getActiveUser() {
            let usersList = this.props.model.projectsMembers.members;
            let activeUserId = this.props.model.projectsMembers.activeUserId;
            let user = usersList.filter(x => x.value === activeUserId && x.memberType === 0)[0];
            return {
                user: user,
                isAdministrator: this.props.model.projectsMembers.isAdministrator
            }
        }

        getProjectMembers() {
            return {
                viewers: this.props.model.viewers.value,
                participants: this.props.model.participants.value
            }
        }

        renderSendQuoteModal = () => {
            if (!this.state.sendQuoteModalVisible) {
                return <React.Fragment/>
            }

            return (
                <ProjectSendQuoteModal
                    id={this.props.model.id.value}
                    visible={this.state.sendQuoteModalVisible}
                    onClose={() => this.setState({sendQuoteModalVisible: false})}
                />
            )
        }

        canSendQuote = () => this.props.model.permission.value.canSendQuote && this.props.model.permission.value.canEdit;

        onTransformToProductionOrderInformationYesClick = () => {
            const item = this.getTransformOption().find(x => x.id === this.transformToProductionOrderValue);
            this.transform(item).then(response => {
                this.setState({
                    transformToProductionOrderInformationModalVisible: false,
                    resultOftransformToProductionOrder: response.data,
                    resultOfTransformToProductionOrderModalVisible: true
                })
            });
        }

        onTransformToProductionOrderInformationNoClick = () => {
            this.setState({
                transformToProductionOrderInformationModalVisible: false
            })
        }

        onCopyQuoteOrderProductionOrderInformationModalCancelClick = () => {
            this.setState({
                copyQuoteOrderProductionOrderInformationModalVisible: false
            })
        }

        onCreateReviseModalYesClick = () => {
            this.setState({
                createReviseModalVisible: false
            })
        }

        onCreateReviseModalCancelClick = () => {
            this.setState({
                createReviseModalVisible: false
            })
        }

        copy = () => {
            ProjectStore.duringCopy = true;
            this.projectApiService.copyAndEdit(ProjectStore.formModel.id.value)
        }

        revise = () => {
            ProjectStore.duringRevise = true;
            this.projectApiService.reviseAndEdit(ProjectStore.formModel.id.value);
        }

        render() {
            let transformOption = this.getTransformOption();
            let activeUser = this.getActiveUser();
            return (
                <div className="project-edit-page">
                    {(ProjectStore.duringCopy || ProjectStore.duringSave || ProjectStore.duringRevise) &&
                        <Loader fillContainer={true} showBalls={false}/>}
                    <div className="page-body-titlebar" style={{position: 'relative'}}>
                        <div className="flex-center-v">
                            <h3 className="page-body-title">{this.getTitle()}</h3>
                            <div className="page-body-title-separator"></div>
                            <div className="mass-export-dropdown">
                                <ProjectDocumentationModal
                                    api={this.projectApiService}
                                    id={this.props.model.id.value}
                                    isOpen={this.state.substationDocumentationModalIsOpen}
                                    onClose={() => {
                                        this.setState({substationDocumentationModalIsOpen: false});
                                    }}
                                />
                                <DeliveryDocumentationModal
                                    api={this.projectApiService}
                                    id={this.props.model.id.value}
                                    isOpen={this.state.deliveryDocumentationModalIsOpen}
                                    onClose={() => {
                                        this.setState({deliveryDocumentationModalIsOpen: false});
                                    }}
                                />
                                <ProjectXlsSpecificationModal
                                    api={this.projectApiService}
                                    id={this.props.model.id.value}
                                    isOpen={this.state.xlsSpecificationModalIsOpen}
                                    onClose={() => {
                                        this.setState({xlsSpecificationModalIsOpen: false});
                                    }}
                                />
                                <ProjectXmlSpecificationModal
                                    api={this.projectApiService}
                                    id={this.props.model.id.value}
                                    isOpen={this.state.xmlSpecificationModalIsOpen}
                                    onClose={() => {
                                        this.setState({xmlSpecificationModalIsOpen: false});
                                    }}
                                />
                                <span className="desktop-only">
                                    <Dropdown
                                        items={this.dropdownOptions}
                                        caption={__("Generate documentation")}
                                        onItemClick={this.onDocsGenerateDropdownItemClick}
                                    />
                                </span>
                            </div>

                            {transformOption.length > 0 &&
                                <div className="mass-export-dropdown project-transform-dropdown desktop-only">
                                    <Dropdown
                                        items={transformOption}
                                        caption={__(this.state.isTransforming ? 'Transforming...' : 'Transform')}
                                        onItemClick={e => this.onTransformClick(e)}
                                    />
                                </div>
                            }

                            <div className="w-auto">
                                {this.canSendQuote() && <Button theme={Button.Theme.BorderOnly} onClick={() => {
                                    if (ProjectStore.dirty) {
                                        this.xMessageUIService.pushNotification({
                                            type: 'warning',
                                            title: __('Warning'),
                                            text: __('Please save document before sending a quote.'),
                                            timeout: 5
                                        });

                                        return;
                                    }

                                    this.setState({sendQuoteModalVisible: true})
                                }}>{__('Send quote')}</Button>}
                            </div>
                        </div>

                        <div className="page-body-action-buttons desktop-only">
                            {this.props.model.permission.value.canCopy &&
                                <Button processing={ProjectStore.duringCopy} theme={Button.Theme.BorderOnly}
                                        onClick={this.onCopyClick}>{__('Copy')}</Button>}
                            {this.props.model.permission.value.canRevise &&
                                <Button processing={ProjectStore.duringRevise} theme={Button.Theme.BorderOnly}
                                        onClick={this.onReviseClick}>{__('Revise')}</Button>}
                            {this.props.model.permission.value.canDelete && <Button theme={Button.Theme.BorderOnly}
                                                                                    onClick={this.onDeleteClick}>{__('Delete')}</Button>}
                            {this.props.model.permission.value.canEdit &&
                                <Button className="button-save" processing={ProjectStore.duringSave}
                                        theme={Button.Theme.BorderOnly} icon={IconSave}
                                        disabled={!ProjectStore.canSave()}
                                        onClick={this.onSaveClick}>{__('Save')}</Button>}
                        </div>

                        <div className="project-edit-page-floaters mobile-only">
                            <ProjectExpandableFloatingDropdown
                                canSave={ProjectStore.canSave}
                                canAddConfiguration={this.props.model.permission.value.canAddConfiguration}
                                canCopy={this.props.model.permission.value.canCopy}
                                canRevise={this.props.model.permission.value.canRevise}
                                canDelete={this.props.model.permission.value.canDelete}
                                transformOptions={transformOption}
                                documentationOptions={this.dropdownOptions}

                                onSaveClick={this.onSaveClick}
                                onDeleteClick={this.onDeleteClick}
                                onCopyClick={this.onCopyClick}
                                onReviseClick={this.onReviseClick}

                                onDocumentationOptionClick={id => this.onDocsGenerateDropdownItemClick({id: id})}
                                onTransformOptionClick={id => this.onTransformClick({id: id})}

                                onCreateNewConfigurationOptionClick={this.onCreateNewConfigurationClick}
                                onAddExistingConfigurationOptionClick={this.onAddExistingConfigurationClick}
                            />
                        </div>
                    </div>

                    <div className="spaced-items-group-xs row row-cards-container rown-no-outer-gutter">
                        <div className="spaced-item column-6 column-xs-12">
                            <div className="multicard --left">
                                <ProjectGeneralInformation
                                    helpInfo={this.props.model.generalInformationHelpInfo.value}
                                    canEdit={this.props.model.permission.value.canEditGeneralInformation}
                                />
                                <ProjectCollaborationCard
                                    helpInfo={this.props.model.collaborationHelpInfo.value}
                                    canEditParticipants={this.props.model.permission.value.canEditCollaborations}
                                    canEditViewers={this.props.model.permission.value.canEditCollaborations}
                                    members={this.props.model.projectsMembers.members}
                                    projectMembers={this.getProjectMembers()}
                                    activeUser={activeUser}
                                    onParticipantsChanged={this.onCollaborationParticipantsChanged}
                                    onViewersChanged={this.onCollaborationViewersChanged}
                                />
                                <ProjectCustomer
                                    helpInfo={this.props.model.customerHelpInfo.value}
                                    canEdit={this.props.model.permission.value.canEditCustomers}
                                    canAddExistingCustomer={this.props.model.permission.value.canAddExistingCustomer}
                                />
                                <FilesCard
                                    id={this.props.model.id.value}
                                    setDirty={() => ProjectStore.setDirty(true)}
                                    helpInfo={this.props.model.filesHelpInfo.value}
                                    duringEdit={ProjectStore.filesDuringEdit}
                                    setDuringEdit={value => ProjectStore.setFilesDuringEdit(value)}
                                    initialFiles={this.props.model.files.items}
                                    initialItemsViewModel={this.props.model.files.itemsViewModel}
                                    allowEdit={this.props.model.permission.value.canEditFiles}
                                    onFilesChange={this.onProjectFilesChange}
                                    documentApiService={ProjectApiService}
                                />
                            </div>
                        </div>

                        <div className="spaced-item column-6 column-xs-12">
                            <div className="multicard --right">
                                <ComunicationCard helpInfo={this.props.model.communicationHelpInfo.value}
                                                  appType={Message.ApplicationType.WebSelect}
                                                  projectId={this.props.model.id.value}
                                                  projectNumber={this.props.model.generalInformation.number.value}
                                                  messageApiService={MessageAPIService}
                                                  messagesApiService={MessagesAPIService}
                                                  />
                                {ProjectStore.formModel.id.value !== 0 && (
                                    <HistoryCard helpInfo={this.props.model.historyHelpInfo.value}
                                                 projectId={ProjectStore.formModel.id.value}
                                                 title={this.props.model.title}
                                                 api={new ProjectApiService()}/>)}
                            </div>

                        </div>
                    </div>

                    <ProjectConfigurations
                        canSetConfigurationOptional={this.props.model.permission.value.canSetConfigurationOptional}
                        canAddConfiguration={this.props.model.permission.value.canAddConfiguration}
                        canEditDiscount={this.props.model.permission.value.canEditDiscount}
                        canEditFactoryCostDiscount={this.props.model.permission.value.canEditFactoryCostDiscount}
                    />
                    <ProjectDeleteModal
                        isOpen={ProjectStore.deleteModalVisible}
                        onDeleteClick={() => this.onDeletePostClick()}
                    />
                    <TransformToProductionOrderInformationModal
                        isOpen={this.state.transformToProductionOrderInformationModalVisible}
                        onYesClick={this.onTransformToProductionOrderInformationYesClick}
                        onNoClick={this.onTransformToProductionOrderInformationNoClick}
                    />
                    <ResultOfTransformToProductionOrderModal
                        isOpen={this.state.resultOfTransformToProductionOrderModalVisible}
                        result={this.state.resultOftransformToProductionOrder}
                    />
                    <CopyQuoteOrderProductionOrderInformationModal
                        name={ProjectStore.formModel.generalInformation.name.value}
                        status={ProjectStore.formModel.generalInformation.status.value}
                        duringCopy={ProjectStore.duringCopy}
                        isOpen={this.state.copyQuoteOrderProductionOrderInformationModalVisible}
                        onYesClick={this.copy}
                        onCancelClick={this.onCopyQuoteOrderProductionOrderInformationModalCancelClick}
                    />
                    <CreateReviseInformationModal
                        isOpen={this.state.createReviseModalVisible}
                        onYesClick={this.revise}
                        onCancelClick={this.onCreateReviseModalCancelClick}
                    />
                    {this.canSendQuote() && this.renderSendQuoteModal()}
                </div>
            );
        }
    }
)

window.components.ProjectEditPage = ProjectEditPage;
